module.exports = __webpack_public_path__ + "assets/3b3b34a28fd2553fb04aa93a6b79ff1d.png";